// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1rvNY","amount":"Amount_amount__3EqIZ","tip":"Amount_tip__1CyDf","tipHeader":"Amount_tipHeader__158ZT","tipsWrap":"Amount_tipsWrap__1eBrf"};